import React from 'react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import HeroHeadlineText from '../HeroHeadlineText';

import clientConfig from '../../../client-config';
import './heroSection.scss';

export default function HeroSection({ heroBannerImage, headlineText, layoutStyle, ...props }) {
  return (
    <div className={`hero-section ${layoutStyle}`}>
      <div className="hero-image fit-img-height">
        <Img fluid={getFluidGatsbyImage(heroBannerImage, { maxWidth: 675 }, clientConfig.sanity)} alt="" />
      </div>
      <HeroHeadlineText headlineText={headlineText} />
    </div>
  );
}
